"use strict";

var roundUp = require('./roundUp');
/**
 * computes the rounded number to be printed given the order type & component's #up and quantity
 * @memberof ShinePrinting/Helpers
 * @param {PrintJob} printJob
 * @param {Product} product
 * @param {Component} component
 * @returns {Number}
 */


function computeRoundedQuantity(component) {
  var up = component.up,
      quantity = component.quantity;
  var num_to_add = 0;

  if (quantity > 5) {
    num_to_add = component.num_to_add == null ? 4 : component.num_to_add;
  }

  if (Number.isNaN(parseInt(up, 10))) {
    return parseInt(quantity, 10) + parseInt(num_to_add, 10);
  }

  return roundUp(parseInt(quantity, 10) + parseInt(num_to_add, 10), up);
}

module.exports = computeRoundedQuantity;